// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"334":"144256e6","757":"73768f3a","794":"cf6059d3","963":"4853495f"}[chunkId] + ".css";
};